<template>
  <v-tabs v-model="tab" background-color="transparent" color="primary" class="horario-tabs" grow>
    <v-tab>DIA</v-tab>
    <v-tab>ÚLTIMOS 10 DIAS</v-tab>
    <v-tab>PERÍODO</v-tab>
  </v-tabs>
</template>

<script>
export default {
  name: "HorarioTabs",
  props: {
    value: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    tab: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>

<style scoped>
.horario-tabs {
  margin-bottom: 0;
}
</style>
